import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Fab } from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import React from "react";
// import { Box } from "@mui/system";

export const MainContainer = (props) => (
  <Box
    sx={{
      display: "flex",
      height: "100vh",
      overflowY: "auto",
    }}
    {...props}
  />
);

export const MainContent = (props) => (
  <Box
    sx={props.sx ? props.sx : {

      p: 4,
      width: "100%",

    }}
    {...props}
  />
);

export const BoxRow = (props) => (
  <Box
    sx={{

      my: 2,
      width: "100%",

    }}
    {...props}
  />
);

export const BoxItem = (props) => (
  <Box
    sx={{
      pt: 2,
    }}
    {...props}
  />
);

export const BoxLabel = (props) => (
  <Box
    sx={{
      fontWeight: "medium",
      m: 0,
    }}
    {...props}
  />
);

export const ActionButton = (props) => (
  <Button
    sx={{
      m: 1,
      py: 1.5,
      px: 8,
      fontSize: 18,
      fontWeight: 500,
  
    }}
    {...props}
  />
);



export const BoxHeader = styled("h2")({
  textAlign: "center",
});


